import axios from 'axios';
import {BaseResponse} from "../../BaseResponse";

export async function deleteEmployee(uid : string) {
    const response = await axios.delete<BaseResponse<boolean>>(`/basic/employee/${uid}`)

    return response.data
}

